import type { Game } from 'chessboard/model/game/types';
import type { NodeKeys } from '../store/types';

/**
 * Determines if a node matches the given the ids and hash
 */
export function isMatchingNode(
  node: Game.Move.Node | null | undefined,
  nodeKeys: NodeKeys | null | undefined,
) {
  if (!node || !nodeKeys) {
    return false;
  }

  const { ids, hash } = nodeKeys;
  return (
    node.ids.line === ids.line &&
    node.ids.move === ids.move &&
    node.hash[0] === hash[0] &&
    node.hash[1] === hash[1]
  );
}
